import React from 'react';
import DefaultButton from '../../../../global/default-button/default-button';
import './list-of-filters.scss';
import { ReportConfigurationViewModel } from '../../_reports/report-configuration/report-configuration.viewmodel';
import Text from '../../../../global/text/text';
import { ISelectableFilter } from '../../../../../api/reports.dao';

interface IProps {
    onSelect: (filter: ISelectableFilter) => void;
    filters: ISelectableFilter[];
    configurationVm: ReportConfigurationViewModel;
}

const ListOfFilters = (props: IProps) => {
    const { onSelect, filters, configurationVm } = props;
    const groupedFiltersList = configurationVm.getGroupedFiltersList(filters);

    const headerColumnsStyle = { gridTemplateColumns: '1fr '.repeat(groupedFiltersList.length)};
    const columnsStyle = { gridTemplateColumns: 'minmax(110px, 1fr) '.repeat(groupedFiltersList.length)};

    return (
        <div className='list-of-filters'>
            <div className='list-of-filters__group-headers' style={headerColumnsStyle}>
                { groupedFiltersList.map(({ groupName }) =>
                    <div key={`${groupName}-header`} className='list-of-filters__group-header'>
                        <Text className='report-grouped-fields__group-header-label' message={groupName} />
                    </div>
                )}
            </div>
            <div className='list-of-filters__group-columns' style={columnsStyle}>
                { groupedFiltersList.map(group =>
                    <div key={`${group.groupName}-column`} className='list-of-filters__items'>
                        { group.items.map(el =>
                            <DefaultButton key={el.field} text={el.label} modifier='link' onClick={() => onSelect(el)} />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ListOfFilters;
